// import React from 'react'
// import './Achievements.css';

// export default function Achievements() {
//     const achievements = [
//         {
//           title: "6th in Google Solution Challenge Hackathon 2023",
//           description: "Organised by Calcutta Institute of Engineering and Management",
//           date: "January 2023",
//         },
//         {
//           title: "Finalist in Smart Bengal Hackathon 2023",
//           description: "Organised by Calcutta Institute of Engineering and Management",
//           date: "April 2023",
//         },
//         {
//           title: "Top 35 in Intra college Smart India Hackthon 2023",
//           description: "Organised by Calcutta Institute of Engineering and Management",
//           date: "September 2023",
//         },
//         {
//           title: "2nd position at Celsius Hackathon 2024",
//           description: "Organised by Calcutta Institute of Engineering and Management",
//           date: "January 2024",
//         },
//         {
//           title: "Finalist in Smart Bengal Hackathon 2024",
//           description: "Organised by Calcutta Institute of Engineering and Management",
//           date: "April 2024",
//         },
//       ];
//   return (
//     <div className="Achievements-App">
//       <h1 className="Achievements-heading">WHAT I HAVE ACHIEVED SO FAR</h1>
//       <h2 className="Achievements-subheading">Achievements</h2>
//       <div className="Achievements-timeline">
//         {achievements.map((achievement, index) => (
//           <div className="Achievements-timeline-item" key={index}>
//             <div className="Achievements-timeline-date">{achievement.date}</div>
//             <div className="Achievements-timeline-content">
//               <h3>{achievement.title}</h3>
//               <p>{achievement.description}</p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   )
// }

import React, { useState } from 'react';
import './Achievements.css';
import gdsc from '../../images/gdsc.jpeg';
import sbh23 from '../../images/sbh2023.jpeg';
import sih from '../../images/sih.jpeg';
import ciem from '../../images/ciem.jpeg';
import sbh24 from '../../images/sbh2024.jpeg';
import japan from '../../images/japan.png';
import AOS from 'aos';
import 'aos/dist/aos.css'

const achievements = [
  {
    date: 'January 2023',
    title: '6th in Google Solution Challenge Hackathon 2023',
    organization: 'Organised by Techno International New Town',
    picture: gdsc,
  },
  {
    date: 'April 2023',
    title: 'Finalist in Smart Bengal Hackathon 2023',
    organization: 'Organised by RCC Institute of Information Technology',
    picture: sbh23,
  },
  {
    date: 'September 2023',
    title: 'Top 35 in Intra college Smart India Hackathon 2023',
    organization: 'Organised by Techno International New Town',
    picture: sih,
  },
  {
    date: 'January 2024',
    title: 'Winner of the Celsius Hackathon 2024',
    organization: 'Organised by Calcutta Institute of Engineering and Management',
    picture: ciem,
  },
  {
    date: 'April 2024',
    title: 'Finalist in Smart Bengal Hackathon 2024',
    organization: 'Organised by RCC Institute of Information Technology',
    picture: sbh24,
  },
  {
    date: 'September 2024',
    title: 'Japan-Sakura Student Science Exchange Program',
    organization: 'Selected as one of the top six students from my college for the Japan-Sakura Student Science Exchange Program, in collaboration with Okayama University, Osaka University and Tokyo University, fully funded by the Japan government',
    picture: japan,
  },
  {
    date: 'May 2025',
    title: 'First Runner-up at Smart Bengal Hackathon 2025',
    organization: 'Organised by RCC Institute of Information Technology',
    picture: null,
  },
  {
    date: 'May 2025',
    title: 'Winner of Proto-X prototype competition 2025',
    organization: 'Organised by Meghnad Saha Institute of Technology',
    picture: null,
  },
];


const Achievements = () => {
  const [selectedAchievement, setSelectedAchievement] = useState(null);

  const openModal = (achievement) => {
    setSelectedAchievement(achievement);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedAchievement(null);
    document.body.style.overflow = 'auto';
  };
  React.useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div className="Achievements-timeline">
      <div className="Achievements-timeline-h1">WHAT I HAVE ACHIEVE SO FAR</div>
      <div className="Achievements-timeline-h2">Achievements</div>
      <div className="Achievements-timelineP"></div>
      {achievements.map((achievement, index) => (
        <div
          key={index}
          data-aos={index % 2 === 0 ? 'fade-right' : 'fade-left'}
          data-aos-delay={0 + index * 200}
          className={`Achievements-container ${index % 2 === 0 ? 'left' : 'right'}`}
          onClick={() => openModal(achievement)}
        >
          <div className="Achievements-content">
            <h3  style={{
                color: '#C00246',
                cursor: "pointer"
              }}> 
              {achievement.date} 🔗
            </h3>
            <p>{achievement.title}</p>
            <i><p style={{ lineHeight: '1.3' }}>{achievement.organization}</p></i>
          </div>
        </div>
      ))}
      {selectedAchievement && (
        <div className="Achievements-modal-overlay" onClick={closeModal}>
          <div className="Achievements-modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-button" onClick={closeModal}>&times;</span>
            <h2>{selectedAchievement.title}</h2>
            <img src={selectedAchievement.picture} alt={selectedAchievement.title} className="achievement-image" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Achievements;
